import React from 'react';
import { TableCell } from '../TableCell';
import { Icons } from '../../../atoms/SVG';
import Btn from '../../../molecules/Btn';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../atoms/Tooltip';

type TableCellEmailButton = {
  label: string;
  emailUrl?: string;
  phoneUrl?: string;
  personName: string;
  cellProperties?: TableCell;
};
export function TableCellContactButtons({
  label,
  cellProperties,
  emailUrl,
  phoneUrl,
  personName,
}: TableCellEmailButton) {
  const { t } = useSonTranslation('Table');
  const emailText = t('generators.emailGenerator.text', { name: personName });
  const phoneText = t('generators.phoneGenerator.titleWithName', { name: personName });

  return (
    <TableCell {...cellProperties} dataHead={label}>
      {emailUrl || phoneUrl ? (
        <div className="tables__cell-contact-buttons">
          {emailUrl ? (
            <Btn
              href={emailUrl}
              svgSpriteId={Icons.MAIL_ENVELOPE}
              hiddenText
              text={emailText}
              titleText={emailText}
              tooltipPlacement={TooltipPlacement.TOP}
            />
          ) : null}
          {phoneUrl ? (
            <Btn
              href={phoneUrl}
              svgSpriteId={Icons.PHONE}
              hiddenText
              text={phoneText}
              titleText={phoneText}
              tooltipPlacement={TooltipPlacement.TOP}
            />
          ) : null}
        </div>
      ) : null}
    </TableCell>
  );
}
